var app = angular.module("leonardo");

var UtilityImportController = function($scope, $state, UnitService, AccountService, NotificationService,
                                       PropertyService, UserService, PropertyAmenityService) {

  $scope.accountService = AccountService;

  $scope.propertyService = PropertyService;

  $scope.entity = $state.current.entity;

  $scope.data = {
    response_email_recipients: []
  };

  $scope.emails = 1;

  $scope.initEntityService = function () {
    switch ($scope.entity) {
      case 'property':
        $scope.utilityService = PropertyService;
        break;
      case 'property-amenity':
        $scope.utilityService = PropertyAmenityService;
        break;
      case 'user':
        $scope.utilityService = UserService;
        break;
      case 'unit':
        $scope.utilityService = UnitService;
        break;
    }
  };

  $scope.getNumber = function(num) {
    return new Array(num);
  };

  $scope.emailsError = function() {
    if (!$scope.Form.$submitted) {
      return false;
    }
    else if ($scope.data.response_email_recipients.length === 0) {
      return true;
    }
    else {
      var error = true;
      angular.forEach($scope.data.response_email_recipients, function(value){
        if (value) {
          error = false;
        }
      });
      return error;
    }
  };

  $scope.getData = function (imp) {
    var data = {
      account: $scope.data.account,
      property: $scope.data.property,
      response_email_recipients: $scope.data.response_email_recipients.join(',')
    };
    if (imp) {
      data.file =  $scope.data.file;
    }
    return data;
  };

  $scope.getEntityName = function(){
    switch ($state.current.entity) {
      case 'property':
        return 'Properties';
      case 'property-amenity':
        return 'Properties Amenities';
      case 'user':
        return 'Users';
      case 'unit':
        return 'Units';
    }
  };

  $scope.import = function () {
    $scope.Form.$setSubmitted();
    if ($scope.emailsError()) {
      return;
    }
    if ($scope.Form.$invalid) {
      return;
    }
    var data = $scope.getData(true);
    $scope.utilityService.importExcel(data).then(function () {
      NotificationService.notify('success', 'Importing ' + $scope.getEntityName() +'. This process may take a few minutes.');
    });
  };

  $scope.export = function () {
    $scope.Form.$setSubmitted();
    if ($scope.emailsError()) {
      return;
    }
    if ($scope.Form.$invalid) {
      return;
    }
    var data = $scope.getData();
    $scope.utilityService.exportExcel(data).then(function () {
      NotificationService.notify('success', 'Exporting ' + $scope.getEntityName() +'. This process may take a few minutes.');
    });
  };

  $scope.initEntityService();

};

app.controller('UtilityImportController', ['$scope', '$state', 'UnitService', 'AccountService', 'NotificationService',
  'PropertyService', 'UserService', 'PropertyAmenityService', UtilityImportController]);